import { Injector } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TreeNode } from "primeng/api";
import { XEVPRMImportedMessage } from "../../../Data/Art57Data/XEVPRMImportedMessage";
import { Art57Node } from "../../Art57Node/Art57Node";
import { Art57NodeUtils } from "../../Art57Node/Art57NodeUtils";
import { TreeNodeAttachmentList } from "../../Art57Node/ListEntity/TreeNodeAttachmentList";
import { TreeNodeProductsList } from "../../Art57Node/ListEntity/TreeNodeProductsList";
import { TreeNodeSubstancesList } from "../../Art57Node/ListEntity/TreeNodeSubstancesList";
import { TreeNodeMasterFileLocationList } from "../../Art57Node/ListEntity/TreeNodeMasterFileLocationList";
import { TreeNodeSourceList } from "../../Art57Node/ListEntity/TreeNodeSourceList";
import { TreeNodeOrganisationList } from "../../Art57Node/ListEntity/TreeNodeOrganisationList";
import { TreeNodeATCCodeList } from "../../Art57Node/ListEntity/TreeNodeATCCodeList";
import { TreeNodePharmaceuticalFormList } from "../../Art57Node/ListEntity/TreeNodePharmaceuticalFormList";
import { TreeNodeRoutesOfAdministrationList } from "../../Art57Node/ListEntity/TreeNodeRoutesOfAdministrationList";
import { FieldsErrorsControl } from "../../../FieldErrorsControl";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { FieldDefinition } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition";

export class TreeNodeXEVPRMImportedMessage extends Art57Node {
  fieldsErrorsControl = new FieldsErrorsControl();

  constructor(private injector: Injector) {
    super(
      injector,
      new XEVPRMImportedMessage(
        new FormGroup({}),
        new FieldDefinition(injector),
        {}
      ),
      'XEVPRM - {param1} - {param2}'
    );
    this.ioc!.get(Art57Section).generateNumColumValue(this);
    this.refreshLabel();
    this.expanded = true;
  }

  override refreshLabel(lazy: boolean = true): void {
    let param1 = '';
    let param2 = '';

    if (
      this.data &&
      this.data.model &&
      this.data.model.messagesenderidentifier
    ) {
      param1 = this.data.model.messagesenderidentifier
    }
    if (
      this.data &&
      this.data.model &&
      this.data.model.messagedate
    ) {
      param2 = this.data.model.messagedate
    }

    this.label = this.labelTemplate.replace('{param1}', param1).replace('{param2}', param2);
  }

  override getListItem(): any[] {
    return [
      this.data.model && this.data.model.messagetype
        ? this.data.model.messagetype :
        '',
      this.data.model && this.data.model.messagenumb
        ? this.data.model.messagenumb :
        '',
      this.data.model && this.data.model.messagedate
        ? this.data.model.messagedate
        : '',
    ];
  }

  createOrRetrieveAuthorisedProductListNode(): Art57Node {
    let productsListNode: TreeNode | null = Art57NodeUtils.findFirstChildNodeOfType(this, TreeNodeProductsList);
    if (productsListNode == null) {
      productsListNode = new TreeNodeProductsList(this.injector, this);
      this.children?.push(productsListNode);
    }

    return (productsListNode as Art57Node);

  }

  private createNodeTypeIfNoExist(type: new (...args: any[]) => Art57Node) {
    let foundNode: TreeNode | null = Art57NodeUtils.findFirstChildNodeOfType(this, type);
    if (foundNode == null) {
      foundNode = new type(this.injector, this);
      this.children?.push(foundNode);
    }

  }
  private importArt57Node(type: new (...args: any[]) => Art57Node, jsonObject: any, section: string, params: any) {
    if (jsonObject) {
      this.createNodeTypeIfNoExist(type);
      Art57NodeUtils.importNodeType(this, jsonObject, section, type, params);
    }

  }

  override setMessage(jsonObject: any) {
    // Import Authorised Products
    if (jsonObject.authorisedproducts) {
      this.importArt57Node(TreeNodeProductsList, jsonObject.authorisedproducts, 'authorisedproduct', { nodeTypeToCreateName: 'addAuthorisedProduct', nodeType: 1 });
    }

    // Import Development Products
    if (jsonObject.developmentproducts) {
      this.importArt57Node(TreeNodeProductsList, jsonObject.developmentproducts, 'developmentproduct', { nodeTypeToCreateName: 'addDevelopmentProduct', nodeType: 2 });
    }

    // Import Approved Substances
    if (jsonObject.approvedsubstances) {
      this.importArt57Node(TreeNodeSubstancesList, jsonObject.approvedsubstances, 'approvedsubstance', { nodeTypeToCreateName: 'addApprovedSubstance', nodeType: 1 });
    }

    // Import Development Substances
    if (jsonObject.developmentsubstances) {
      this.importArt57Node(TreeNodeSubstancesList, jsonObject.developmentsubstances, 'developmentsubstance', { nodeTypeToCreateName: 'addDevelopmentSubstance', nodeType: 2 });
    }

    // Import sources
    if (jsonObject.sources) {
      this.importArt57Node(TreeNodeSourceList, jsonObject.sources, 'source', {});
    }
    // Import Organisations
    this.importOrganisations(jsonObject);

    // Import atc codes
    this.importAtcCodes(jsonObject);

    // Import pharmaceutical forms
    this.importPharmaceuticalForms(jsonObject);

    // Import routes of administration
    this.importRoutesOfAdministration(jsonObject);

    // Import Attachments (PPI/PSI)
    this.importAttachments(jsonObject);

    // Import Master File Locations
    if (jsonObject.masterfilelocations) {
      this.importArt57Node(TreeNodeMasterFileLocationList, jsonObject.masterfilelocations, 'masterfilelocation', {});
    }
  }

  private importAttachments(jsonObject: any) {
    if (jsonObject.attachments && jsonObject.attachments.attachment) {
      const ppiAttachments = jsonObject.attachments.attachment.filter((item: any) => {
        return item.attachmenttype == 1;
      });


      if (ppiAttachments && (ppiAttachments.length > 0)) {
        const ppiAttachmentsJSON = {
          attachments: {
            attachment: ppiAttachments
          }
        };
        this.importArt57Node(TreeNodeAttachmentList, ppiAttachmentsJSON.attachments, 'attachment', { nodeTypeToCreateName: '', nodeType: 1 });
      }

      const psiAttachments = jsonObject.attachments.attachment.filter((item: any) => {
        return item.attachmenttype == 2;
      });

      if (psiAttachments && (psiAttachments.length > 0)) {

        const psiAttachmentsJSON = {
          attachments: {
            attachment: psiAttachments
          }
        };
        this.importArt57Node(TreeNodeAttachmentList, psiAttachmentsJSON.attachments, 'attachment', { nodeTypeToCreateName: '', nodeType: 2 });
      }

    }

  }

  private importOrganisations(jsonObject: any) {

    if (jsonObject.organisations && jsonObject.organisations.organisation) {
      const mahOrganisations = jsonObject.organisations.organisation.filter((item: any) => {
        return item.type_Org == 1;
      });



      if (mahOrganisations && (mahOrganisations.length > 0)) {
        const mahOrganisationsJSON = {
          organisations: {
            organisation: mahOrganisations
          }
        };
        this.importArt57Node(TreeNodeOrganisationList,
          mahOrganisationsJSON.organisations,
          'organisation',
          { nodeTypeToCreateName: 'addOrganisation', nodeType: 1 });
      }

      const sponsorOrganisations = jsonObject.organisations.organisation.filter((item: any) => {
        return item.type_Org == 2;
      });

      if (sponsorOrganisations && (sponsorOrganisations.length > 0)) {
        const sponsorOrganisationsJSON = {
          organisations: {
            organisation: sponsorOrganisations
          }
        };
        this.importArt57Node(TreeNodeOrganisationList, sponsorOrganisationsJSON.organisations, 'organisation', { nodeTypeToCreateName: 'addOrganisation', nodeType: 2 });
      }

    }
  }

  private importAtcCodes(jsonObject: any) {
    if (jsonObject.standardterminology && jsonObject.standardterminology.atcs && jsonObject.standardterminology.atcs.atc) {
      const developmentAtcCode = jsonObject.standardterminology.atcs.atc.filter((item: any) => {
        return item.type_Term == 1;
      });


      if (developmentAtcCode && (developmentAtcCode.length > 0)) {
        const developmentAtcCodeJSON = {
          atcs: {
            atc: developmentAtcCode
          }
        };
        this.importArt57Node(TreeNodeATCCodeList, developmentAtcCodeJSON.atcs, 'atc', { nodeTypeToCreateName: 'addATCCode', nodeType: 1 });
      }

      const proposedAtcCode = jsonObject.standardterminology.atcs.atc.filter((item: any) => {
        return item.type_Term == 2;
      });



      if (proposedAtcCode && proposedAtcCode.length > 0) {
        const proposedAtcCodeJSON = {
          atcs: {
            atc: proposedAtcCode
          }
        };
        this.importArt57Node(TreeNodeATCCodeList, proposedAtcCodeJSON.atcs, 'atc', { nodeTypeToCreateName: 'addATCCode', nodeType: 2 });
      }

      const standardAtcCode = jsonObject.standardterminology.atcs.atc.filter((item: any) => {
        return item.type_Term == 3;
      });


      if (standardAtcCode && (standardAtcCode.length>0)) {
        const standardAtcCodeJSON = {
          atcs: {
            atc: standardAtcCode
          }
        };
        this.importArt57Node(TreeNodeATCCodeList, standardAtcCodeJSON.atcs, 'atc', { nodeTypeToCreateName: 'addATCCode', nodeType: 3 });
      }

    }
  }

  private importPharmaceuticalForms(jsonObject: any) {
    if (jsonObject.standardterminology && jsonObject.standardterminology.pharmaceuticalforms && jsonObject.standardterminology.pharmaceuticalforms.pharmaceuticalform) {
      const developmentPharmaceuticalForm = jsonObject.standardterminology.pharmaceuticalforms.pharmaceuticalform.filter((item: any) => {
        return item.type_Term == 1;
      });



      if (developmentPharmaceuticalForm && (developmentPharmaceuticalForm.length > 0)) {
        const developmentPharmaceuticalFormJSON = {
          pharmaceuticalforms: {
            pharmaceuticalform: developmentPharmaceuticalForm
          }
        };
        this.importArt57Node(TreeNodePharmaceuticalFormList, developmentPharmaceuticalFormJSON.pharmaceuticalforms, 'pharmaceuticalform', { nodeTypeToCreateName: 'addPharmaceuticalForms', nodeType: 1 });
      }

      const proposedPharmaceuticalForm = jsonObject.standardterminology.pharmaceuticalforms.pharmaceuticalform.filter((item: any) => {
        return item.type_Term == 2;
      });

      if (proposedPharmaceuticalForm && (proposedPharmaceuticalForm.length > 0)) {
        const proposedPharmaceuticalFormJSON = {
          pharmaceuticalforms: {
            pharmaceuticalform: proposedPharmaceuticalForm
          }
        };
        this.importArt57Node(TreeNodePharmaceuticalFormList, proposedPharmaceuticalFormJSON.pharmaceuticalforms, 'pharmaceuticalform', { nodeTypeToCreateName: 'addPharmaceuticalForms', nodeType: 2 });
      }

      const standardPharmaceuticalForm = jsonObject.standardterminology.pharmaceuticalforms.pharmaceuticalform.filter((item: any) => {
        return item.type_Term == 3;
      });

      if (standardPharmaceuticalForm && (standardPharmaceuticalForm.length > 0)) {
        const standardPharmaceuticalFormJSON = {
          pharmaceuticalforms: {
            pharmaceuticalform: standardPharmaceuticalForm
          }
        };
        this.importArt57Node(TreeNodePharmaceuticalFormList, standardPharmaceuticalFormJSON.pharmaceuticalforms, 'pharmaceuticalform', { nodeTypeToCreateName: 'addPharmaceuticalForms', nodeType: 3 });
      }

    }
  }

  private importRoutesOfAdministration(jsonObject: any) {
    if (jsonObject.standardterminology && jsonObject.standardterminology.administrationroutes && jsonObject.standardterminology.administrationroutes.administrationroute) {
      const developmentRoutesOfAdministration = jsonObject.standardterminology.administrationroutes.administrationroute.filter((item: any) => {
        return item.type_Term == 1;
      });


      if (developmentRoutesOfAdministration && developmentRoutesOfAdministration.length > 0) {
        const developmentRoutesOfAdministrationJSON = {
          administrationroutes: {
            administrationroute: developmentRoutesOfAdministration
          }
        };
        this.importArt57Node(TreeNodeRoutesOfAdministrationList, developmentRoutesOfAdministrationJSON.administrationroutes, 'administrationroute', { nodeTypeToCreateName: 'addRoutesOfAdministration', nodeType: 1 });
      }

      const proposedRoutesOfAdministration = jsonObject.standardterminology.administrationroutes.administrationroute.filter((item: any) => {
        return item.type_Term == 2;
      });

      if (proposedRoutesOfAdministration && proposedRoutesOfAdministration.length > 0) {
        const proposedRoutesOfAdministrationJSON = {
          administrationroutes: {
            administrationroute: proposedRoutesOfAdministration
          }
        };
        this.importArt57Node(TreeNodeRoutesOfAdministrationList, proposedRoutesOfAdministrationJSON.administrationroutes, 'administrationroute', { nodeTypeToCreateName: 'addRoutesOfAdministration', nodeType: 2 });
      }

      const standardRoutesOfAdministration = jsonObject.standardterminology.administrationroutes.administrationroute.filter((item: any) => {
        return item.type_Term == 3;
      });


      if (standardRoutesOfAdministration && standardRoutesOfAdministration.length > 0) {
        const standardRoutesOfAdministrationJSON = {
          administrationroutes: {
            administrationroute: standardRoutesOfAdministration
          }
        };
        this.importArt57Node(TreeNodeRoutesOfAdministrationList, standardRoutesOfAdministrationJSON.administrationroutes, 'administrationroute', { nodeTypeToCreateName: 'addRoutesOfAdministration', nodeType: 3 });
      }

    }
  }


}